import React from "react";
import "../Styles/Header.css";
import SolaceAcademyLogo from "../Assets/SolaceAcademyLogo.png";

const Header = () => {
  return (
    <div className="header-div">
      <img
        src={SolaceAcademyLogo}
        alt="Solace logo"
        className="solace-logo"
      ></img>
    </div>
  );
};

export default Header;
